import SchoolRecordInput from "./SchoolRecordInput"

const AcademicRecordTable = ({ register, isRead = false }) => {
    return (
        <div>
            <div className='d-flex w-full' style={{ border: "1px solid #888", borderBottom: "0" }}>
                <div style={{ width: "33.33333%" }} className='d-flex justify-content-center align-items-center py-2'>Enrollment</div>
                <div style={{ width: "33.33333%", borderLeft: "1px solid #888", borderRight: "1px solid #888" }} className='d-flex justify-content-center align-items-center py-2'>
                    <div className='d-flex align-items-center gap-2'>
                        <span className='shrink-0'>From:</span>
                        <SchoolRecordInput type={'date'} register={register} name={'academicRecord.enrollment.from'} isRead={isRead} />
                    </div>
                </div>
                <div style={{ width: "33.33333%" }} className='d-flex justify-content-center align-items-center py-2'>
                    <div className='d-flex align-items-center gap-2'>
                        <span className='shrink-0'>To:</span>
                        <SchoolRecordInput type={'date'} register={register} name={'academicRecord.enrollment.to'} isRead={isRead} />
                    </div>
                </div>
            </div>

            <table className='table table-bordered table-sm text-center align-middle'>
                <thead>
                    <tr className='align-middle'>
                        <th rowSpan={2} colSpan={4}>Subjects</th>
                        <th colSpan={2}>G10</th>
                        <th colSpan={2}>G11</th>
                        <th colSpan={2}>G12</th>
                    </tr>
                    <tr>
                        <th>1st</th>
                        <th>2nd</th>
                        <th>1st</th>
                        <th>2nd</th>
                        <th>1st</th>
                        <th>2nd</th>
                    </tr>
                </thead>
                <tbody>
                    {/* Cambridge */}
                    <tr>
                        <td rowSpan={17}>Cambridge Subjects</td>
                        <td colSpan={2}>English as a Second Language </td>
                        <td>IGCSE</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.second_lang`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.second_lang`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.second_lang`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.second_lang`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.second_lang`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.second_lang`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td colSpan={2}>English Language</td>
                        <td>AS/A level</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.eng`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.eng`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.eng`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.eng`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.eng`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.eng`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td rowSpan={2} colSpan={2}>Mathematics</td>
                        <td>IGCSE</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.math.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.math.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.math.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.math.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.math.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.math.igc`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>AS/A level</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.math.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.math.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.math.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.math.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.math.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.math.as`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td rowSpan={6}>Science</td>
                        <td rowSpan={2}>Biology</td>
                        <td>IGCSE</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.science.biology.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.science.biology.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.science.biology.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.science.biology.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.science.biology.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.science.biology.igc`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>AS/A level</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.science.biology.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.science.biology.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.science.biology.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.science.biology.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.science.biology.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.science.biology.as`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td rowSpan={2}>Chemistry</td>
                        <td>IGCSE</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.science.chemistry.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.science.chemistry.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.science.chemistry.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.science.chemistry.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.science.chemistry.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.science.chemistry.igc`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>AS/A level</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.science.chemistry.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.science.chemistry.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.science.chemistry.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.science.chemistry.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.science.chemistry.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.science.chemistry.as`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td rowSpan={2}>Physics</td>
                        <td>IGCSE</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.science.physics.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.science.physics.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.science.physics.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.science.physics.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.science.physics.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.science.physics.igc`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>AS/A level</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.science.physics.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.science.physics.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.science.physics.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.science.physics.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.science.physics.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.science.physics.as`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td rowSpan={7}>Social Studies</td>
                        <td>Global Perspectives</td>
                        <td>IGCSE</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.social.global`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.social.global`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.social.global`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.social.global`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.social.global`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.social.global`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td rowSpan={2}>History</td>
                        <td>IGCSE</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.social.history.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.social.history.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.social.history.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.social.history.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.social.history.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.social.history.igc`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>AS/A level</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.social.history.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.social.history.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.social.history.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.social.history.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.social.history.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.social.history.as`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td rowSpan={2}>Business</td>
                        <td>IGCSE</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.social.business.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.social.business.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.social.business.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.social.business.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.social.business.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.social.business.igc`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>AS/A level</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.social.business.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.social.business.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.social.business.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.social.business.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.social.business.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.social.business.as`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td rowSpan={2}>Economics</td>
                        <td>IGCSE</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.social.economics.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.social.economics.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.social.economics.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.social.economics.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.social.economics.igc`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.social.economics.igc`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>AS/A level</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.cambridge.social.economics.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.cambridge.social.economics.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.cambridge.social.economics.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.cambridge.social.economics.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.cambridge.social.economics.as`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.cambridge.social.economics.as`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>


                    {/* Korean */}
                    <tr>
                        <td rowSpan={10}>Korean Subjects</td>
                        <td colSpan={3}>국어(Korean)</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.korean.korean`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.korean.korean`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.korean.korean`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.korean.korean`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.korean.korean`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.korean.korean`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3}>문학(Literature)</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.korean.literature`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.korean.literature`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.korean.literature`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.korean.literature`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.korean.literature`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.korean.literature`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3}>화법과 작문(Speech and writing)</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.korean.speech`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.korean.speech`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.korean.speech`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.korean.speech`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.korean.speech`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.korean.speech`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3}>언어와 매체(Language and Media)</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.korean.speech`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.korean.speech`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.korean.speech`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.korean.speech`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.korean.speech`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.korean.speech`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3}>독서(Reading)</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.korean.reading`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.korean.reading`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.korean.reading`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.korean.reading`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.korean.reading`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.korean.reading`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3}>고등수학(High school math)</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.korean.high_math`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.korean.high_math`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.korean.high_math`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.korean.high_math`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.korean.high_math`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.korean.high_math`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3}>수학Ⅰ(Mathematics Ⅰ)</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.korean.math1`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.korean.math1`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.korean.math1`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.korean.math1`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.korean.math1`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.korean.math1`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3}>수학Ⅱ(Mathematics Ⅱ)</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.korean.math2`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.korean.math2`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.korean.math2`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.korean.math2`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.korean.math2`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.korean.math2`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3}>미적분(Calculus)</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.korean.calculus`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.korean.calculus`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.korean.calculus`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.korean.calculus`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.korean.calculus`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.korean.calculus`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3}>확률과 통계 (Probability and Statistics)</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.korean.probability`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.korean.probability`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.korean.probability`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.korean.probability`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.korean.probability`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.korean.probability`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>


                    {/* Etc */}
                    <tr>
                        <td colSpan={4}>English Reading&Grammar Ⅰ</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.eng_reading_1`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.eng_reading_1`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.eng_reading_1`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.eng_reading_1`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.eng_reading_1`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.eng_reading_1`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4}>English Reading&Grammar Ⅱ</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.eng_reading_2`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.eng_reading_2`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.eng_reading_2`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.eng_reading_2`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.eng_reading_2`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.eng_reading_2`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4}>English Academic Reading</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.academic_reading`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.academic_reading`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.academic_reading`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.academic_reading`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.academic_reading`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.academic_reading`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4}>Vietnamese</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.vietnamese`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.vietnamese`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.vietnamese`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.vietnamese`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.vietnamese`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.vietnamese`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4}>Physical Education</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.pe`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.pe`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.pe`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.pe`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.pe`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.pe`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4}>Club Activity</td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.first.club`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g10.second.club`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.first.club`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g11.second.club`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.first.club`}
                                isRead={isRead}
                            />
                        </td>
                        <td>
                            <RecordSelect
                                register={register}
                                name={`academicRecord.records.g12.second.club`}
                                isRead={isRead}
                            />
                        </td>
                    </tr>


                    {/* Electives Activities */}
                    {Array(8).fill(0).map((_, idx) => {
                        return (
                            <tr key={`academic_record_row_${idx}`}>
                                {idx === 0 && <td rowSpan={8} colSpan={2}>Electives Activities</td>}
                                <td colSpan={2}>
                                    <SchoolRecordInput register={register} name={`academicRecord.records.electives.${idx}`} isRead={isRead} />
                                </td>
                                <td>
                                    <RecordSelect
                                        register={register}
                                        name={`academicRecord.records.g10.first.electives.${idx}`}
                                        isRead={isRead}
                                    />
                                </td>
                                <td>
                                    <RecordSelect
                                        register={register}
                                        name={`academicRecord.records.g10.second.electives.${idx}`}
                                        isRead={isRead}
                                    />
                                </td>
                                <td>
                                    <RecordSelect
                                        register={register}
                                        name={`academicRecord.records.g11.first.electives.${idx}`}
                                        isRead={isRead}
                                    />
                                </td>
                                <td>
                                    <RecordSelect
                                        register={register}
                                        name={`academicRecord.records.g11.second.electives.${idx}`}
                                        isRead={isRead}
                                    />
                                </td>
                                <td>
                                    <RecordSelect
                                        register={register}
                                        name={`academicRecord.records.g12.first.electives.${idx}`}
                                        isRead={isRead}
                                    />
                                </td>
                                <td>
                                    <RecordSelect
                                        register={register}
                                        name={`academicRecord.records.g12.second.electives.${idx}`}
                                        isRead={isRead}
                                    />
                                </td>
                            </tr>
                        )
                    })}

                </tbody>
            </table>
        </div>
    )
}

const RecordSelect = ({ register, name, isRead = false }) => {
    if (!register) return ''

    return (
        <select
            {...register(name)}
            className={isRead ? 'form-control form-control-sm text-center border-0 bg-transparent' : "form-control form-control-sm"}
            disabled={isRead}
        >
            <option value=""></option>
            <option value="A+">A+</option>
            <option value="A">A</option>
            <option value="B+">B+</option>
            <option value="B">B</option>
            <option value="C+">C+</option>
            <option value="C">C</option>
            <option value="D+">D+</option>
            <option value="D">D</option>
            <option value="E">E</option>
            <option value="P">P</option>
        </select>
    )

}

export default AcademicRecordTable